<template>
  <div class="stiching">
    <img ref="img" :src="img" />
    <img ref="img" :src="img" />
    <img ref="img" :src="img" />
    <img ref="img" :src="img" />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      img: null,
    };
  },
  mounted() {
    this.img = require(`../assets/preview-${this.name}.png`);
  },
};
</script>

<style lang="scss" scoped>
.stiching {
  display: flex;
  width: fit-content;
  img {
    width: auto;
  }
}
</style>
